<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="TypeVal" @change="ReSetPage" clearable placeholder="申请类型">
                    <el-option v-for="i in RowType" :key="i.id" :label="i.group_name" :value="i.id"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="SortVal" @change="ReSetPage" clearable placeholder="排序">
                    <el-option label="总分升序" value="1"></el-option>
                    <el-option label="总分降序" value="2"></el-option>
                    <el-option label="平均分升序" value="3"></el-option>
                    <el-option label="平均分降序" value="4"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="StateVal" @change="ReSetPage" clearable placeholder="状态">
                    <el-option v-for="item in QueryList.final_sq_status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead"></div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading">
            <el-table-column prop="record_number" label="编号" min-width="50"></el-table-column>
            <el-table-column prop="record_name" label="标题" min-width="150"></el-table-column>
            <el-table-column prop="system_sub_id_name" label="所属项目" min-width="80"></el-table-column>
            <el-table-column prop="user_name" label="申请人" min-width="50"></el-table-column>
            <el-table-column prop="djs" label="评审倒计时" min-width="80">
                <template slot-scope="scope">
                    <div v-if="scope.row.sq_status==6 && scope.row.djs>0 && scope.row.is_final_kai">
                        <Time :seconds="scope.row.djs" @update:seconds="scope.row.djs = $event"/>
                    </div>
                    <div v-if="scope.row.djs<0" class="Red">已超时</div>
                    <div v-if="!scope.row.is_final_kai">已暂停</div>
                </template>
            </el-table-column>
            <el-table-column prop="pingfen" label="总评分" min-width="50"></el-table-column>
            <!-- <el-table-column prop="pingjunfen" label="每项平均分" min-width="50"></el-table-column> -->
            <el-table-column prop="sq_status_name" label="状态" min-width="50">
                <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.sq_status_name}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="180" align="center">
                <template slot-scope="scope">
                    <!-- <el-tooltip effect="dark" content="审核" placement="top-start">
                        <i v-if="scope.row.sq_status==5 || scope.row.sq_status==6|| scope.row.sq_status==7" class="NavIcon el-icon-s-check" @click="ToggleAudit(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="总结" placement="top-start">
                        <i v-if="scope.row.identity && scope.row.leader_summary_required" class="NavIcon el-icon-s-claim" @click="ToggleZJ(scope.row)"></i> 
                    </el-tooltip>
                    <el-tooltip effect="dark" content="评审人员查看" placement="top-start">
                        <i v-if="scope.row.identity" class="NavIcon iconfont icon-shenhe" @click="LockPS(scope.row)"></i> 
                    </el-tooltip>
                    <el-tooltip effect="dark" content="查看" placement="top-start">                        
                        <i class="NavIcon el-icon-view" @click="LockDig(scope.row)"></i>                    
                    </el-tooltip>
                    <el-tooltip effect="dark" content="下载" placement="top-start">
                        <!-- <i class="NavIcon el-icon-download" @click="DownFile(scope.row.id)"></i>
                    </el-tooltip> -->
                    <el-button v-if="scope.row.sq_status==5 || scope.row.sq_status==6|| scope.row.sq_status==7" v-throttle type="primary" size="mini" @click="ToggleAudit(scope.row)">审核</el-button>
                    <el-button v-if="scope.row.identity && scope.row.leader_summary_required" v-throttle type="primary" size="mini" @click="ToggleZJ(scope.row)">总结</el-button>
                    <el-button v-if="scope.row.identity" v-throttle type="primary" size="mini" @click="LockPS(scope.row)">评审查看</el-button>
                    <el-button v-throttle type="primary" size="mini" @click="LockDig(scope.row)">信息查看</el-button>
                    <el-button v-throttle type="primary" size="mini" @click="DownFile(scope.row.id)">资料下载</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
        <FieldMol :visible="NewData.NewBlon" :BaoCun="false" :Type="Type" :rowData="RowData" :newData="NewData" @cancel="$Tools.ResetData(NewData)"/>
        <PingShenInfo :visible="PSBlon" :rowData="PSData" @cancel="PSBlon = false" />
        <AuditMol v-if="AuditData.AuditBlon" 
        :ZuZhang="AuditData.AuditZuZhang" 
        :rowData="RowData" 
        :newData="NewData" 
        :BaoCun="AuditData.AuditBaoCun" 
        :itemList="ItemList" 
        :auditRemark="AuditData.AuditRemark"
        :Type="ApiType"
        @cancel="$Tools.ResetData(AuditData)" 
        @submit="SucData" />
        <el-dialog :title="'总结'" :visible.sync="ZJData.blon" width="50%" class="BorderRadius">
            <div class="MaxHei">
                <div class="DigItem">
                    <div class="DigItemWidTit">总结：</div>
                    <el-input class="Wid" size="medium" type="textarea" :rows="2" placeholder="请输入总结" v-model="ZJData.zz_zj"></el-input>
                </div>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(ZJData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ZJSuc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "",
        data() {
            return {
                loading:false,
                SearchVal:"",
                TypeVal:"",
                SortVal:"",
                StateVal:"",
                QueryList:"",
                RowType:[],
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Lock',
                NewData:{
                    id:'',
                    NewBlon:false,
                    record_name:"",
                },
                ItemList:[],//初始化规则项
                RowData:{//资料数据
                    group: [],
                    gl_file: [],
                },
                AuditData:{
                    id:"",
                    AuditId:"",
                    AuditBlon:false,
                    AuditRemark:"",
                    AuditZuZhang:0,
                    AuditBaoCun:0,
                },
                PSData:{},//评审数据
                PSBlon:false,
                ZJData:{  //总结数据
                    blon:false,
                    id:"",
                    ruid:"",
                    zz_zj:"",
                },
            };
        },
        props: ['ApiType'],
        mounted() {
            this.GetData();
            this.GetQuery();
            this.GetTypeData();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/api/expert_portal/final/list',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    system_code:this.ApiType,
                    sq_status:this.StateVal,
                    group_id:this.TypeVal,
                    pingfenSort:this.SortVal,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetTypeData(){
                this.$get('/api/expert_portal/info_collection_group',{
                    page:1,
                    page_size:1000,
                    system_code:this.ApiType,
                }).then(res=>{
                    if(res){
                        this.RowType = res.data.list;
                    }
                })
            },
            GetQuery(){
                this.$get('/api/auth/system').then(res=>{
                    if(res){
                        this.QueryList = res.data;
                    }
                })
            },
            GetList(id){
                this.$get('api/expert_portal/final/gradeData',{
                    system_code:this.ApiType,
                    id:id,
                }).then(res=>{
                    if(res){
                        this.ItemList=res.data.map(i=>{
                            if(i.text_content){i.text_content = JSON.parse(i.text_content)}
                            i.rating = "";
                            i.opinion = "";
                            return i;
                        });
                    }
                })
            },
            GetDetail(id){
                this.$get('/api/expert_portal/final/detail',{
                    id:id,
                    system_code:this.ApiType,
                }).then(res=>{
                    if(res){
                        var Data = JSON.parse(JSON.stringify(res.data));
                        Data.group = Data.group.map(item=>{
                            if (item.field_options && typeof item.field_options === 'string') {
                                try {
                                    item.field_options = JSON.parse(item.field_options);
                                    if(item.field_type == 'checkbox'){item.default_value = item.default_value?item.default_value.split(","):[];}
                                } catch (e) {
                                    item.field_options = [];
                                }
                            }
                            return item;
                        })
                        Data.gl_file = Data.gl_file?Data.gl_file.split(","):[];
                        this.RowData = Data;
                        if(res.data.rule.length>0){
                            this.AuditData.AuditRemark = res.data.opinion;
                            this.ItemList=res.data.rule.map(i=>{
                                if(i.text_content){i.text_content = JSON.parse(i.text_content)}
                                return i;
                            });
                        }else{
                            this.GetList(id);
                        }
                    }
                })
            },
            LockPS(row){
                this.$post('/api/expert_portal/final/gradeinfo',{
                    id:row.id,
                    ruid:row.ruid,
                }).then(res=>{
                    if(res){
                        this.PSBlon = true;
                        this.PSData = res.data;
                    }
                })
            },
            LockDig(row){
                this.NewData.record_name = row.record_name;
                this.GetDetail(row.id)
                this.NewData.NewBlon = true;
            },
            ToggleAudit(row){
                this.NewData.record_name = row.record_name;
                this.$Tools.ResetData(this.AuditData)
                this.AuditData.id = row.id;
                this.AuditData.AuditId = row.ruid;
                this.AuditData.AuditZuZhang =row.identity;
                this.AuditData.AuditBaoCun =row.is_pf;
                this.GetDetail(row.id);
                this.AuditData.AuditBlon = true;
            },
            SucData(data,n,remark){
                var Arr = [];
                data.forEach(i=>{
                    Arr.push({
                        id:i.score_rule_id || i.id,
                        rating:i.rating,
                        opinion:i.opinion,
                        indicator:i.indicator,
                    })
                });
                this.$post("/api/expert_portal/final/grade",{
                    id:this.AuditData.id,
                    ruid:this.AuditData.AuditId,
                    opinion:remark,
                    data:Arr,
                    is_tj:n
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.AuditData)
                    }
                })
            },
            ToggleZJ(row){
                this.ZJData.id = row.id;
                this.ZJData.ruid = row.ruid;
                this.ZJData.zz_zj = row.zz_zj;
                this.ZJData.blon = true;
            },
            ZJSuc(){
                this.$post("/api/expert_portal/final/zonjie",this.ZJData).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.ZJData)
                    }
                })
            },
            DownFile(id){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/api/expert_portal/final/export',{
                        id:id,
                    }).then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    .MaxHei{
        max-height: 500px;
        overflow-y: auto;
    }
    .DisFlex{
        display: flex;
        align-items: center;
    }
    .FuJianPos{
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
    .FuJianAbs{
        position: absolute;
        top: -5px;
        right: -15px;
        font-size: 14px;
        color: #d51938;
    }
    .TableBg{
        background: #dcdcdc;
    }
    .TablePad{
        padding: 10px 0;
        font-weight: 700;
    }
    .Wid30{
        width: 35%;
    }
    .Wid70{
        width: 65%;
    }
    .TableNum{
        padding-bottom: 10px;
        font-weight: 700;
    }
    .DigTable{
        border: 1px solid #028b8b;
        margin-bottom: 10px;
    }
    .DigTableTop{
        display: flex;
        border-bottom: 1px solid #028b8b;
    }
    .DigTableHead{
        border-bottom: 1px solid #028b8b;
    }
    .DigTableDis{
        display: flex;
    }
    .ItemDis{
        display: flex;
        align-items: center;
    }
    .DigTableBor{
        text-align: center;
        border-right: 1px solid #028b8b;
    }
    .DigTableBor:last-child{
        border: 0;
    }
    .ItemTit{
        width: 130px;
        font-weight: 500;
        font-size: 18px;
        padding: 5px;
    }
    .ItemFuTit{
        flex: 1;
        padding: 5px;
        border-left: 1px solid #028b8b;
        text-align: center;
    }
    .ItemQz{
        padding-top: 5px;
    }
    .ItemRadio{
        height: 50%;
    }
    .ItemRadio .Radio{
        height: 100%;
        display: inline-block;
        position: relative;
    }
    .RadioCer{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }
    .RadioCer input{
        margin-top: 0;
    }
    .RadioCer span{
        font-size: 12px;
    }
    .ItemRadio .Radio::after{
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }
    .ItemRadioMsg{
        height: 50%;
        border-top: 1px solid #028b8b;
    }
    .ItemRadioMsg .ItemRadioMsgDom{
        height: 100%;
        display: inline-block;
        position: relative;
    }
    .ItemRadioMsg .ItemRadioMsgDom::after{
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        height: 100%;
        border-right: 1px solid #028b8b;
    }
    .ItemMsg{
        padding: 5px;
        border-top: 1px solid #028b8b;
    }
    .ItemRadio .Radio:last-child::after,
    .ItemRadioMsg .ItemRadioMsgDom:last-child::after,
    .DigTableHead:last-child{
        border: 0;
    }
</style>
